"use strict";
AGA.log = function (message) {
    if (console && console.log) {
        console.log(message);
    }
};
